import React from "react";
import { NavLink } from "react-router";
import logoImage from "./assets/logo.png";

const LAST_UPDATED = "2025-12-21";

const TermsOfService = () => {
  return (
    <div className="h-screen w-full bg-white text-[#0B1120] font-sans overflow-y-auto">
      <header className="sticky top-0 z-10 bg-white/90 backdrop-blur border-b border-gray-100">
        <div className="max-w-4xl mx-auto px-6 py-5 flex items-center justify-between">
          <NavLink to="/" className="flex items-center gap-3">
            <img src={logoImage} alt="neurohubs" className="h-7 w-7 object-contain" />
            <span className="text-base font-semibold tracking-tight text-blue-600">
              Neurohubs
            </span>
          </NavLink>
          <NavLink
            to="/"
            className="text-sm font-medium border border-slate-200 px-5 py-2 rounded-full hover:bg-slate-900 hover:text-white transition-all"
          >
            Back
          </NavLink>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">
          Terms of Service
        </h1>
        <p className="text-sm text-gray-500 mt-2">Last updated: {LAST_UPDATED}</p>

        <div className="mt-10 space-y-8 text-gray-700 leading-relaxed">
          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Acceptance</h2>
            <p>
              By accessing or using Neurohubs, you agree to these Terms of Service.
              If you do not agree, do not use the service.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Intended use and disclaimer</h2>
            <p>
              Neurohubs is a software tool designed to support analysis workflows.
              It is provided for informational and workflow-support purposes and is
              not a substitute for professional medical judgment.
            </p>
            <p className="text-sm text-gray-500">
              The current version is not marketed as a certified medical device and
              is not intended to meet CE Class IIa medical device requirements.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">User responsibilities</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the service lawfully and responsibly.</li>
              <li>
                Ensure you have the necessary rights and legal basis to upload and
                process any data (including patient-related data).
              </li>
              <li>
                Maintain the confidentiality of your account credentials and notify
                us of unauthorized access.
              </li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Uploaded content</h2>
            <p>
              You retain ownership of any data you upload. You are solely
              responsible for the content you upload and for ensuring that it is
              lawful and does not violate third-party rights.
            </p>
            <p>
              By uploading content, you grant us a limited, non-exclusive license
              to process it for the purpose of providing the service (including
              generating analyses, derived metrics, and visualizations).
            </p>
            <p>
              For processing, we primarily rely on quantitative qEEG measurement
              fields (for example, band-power amplitudes and relative power
              percentages) and associated time-related metadata (such as
              recording/report dates). We do not intentionally map these
              measurements to a specific real-world identity.
            </p>
            <p>
              Do not upload direct identifiers (e.g., patient names, national IDs,
              phone numbers, addresses) unless you have a lawful basis and it is
              necessary for your workflow.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Prohibited use</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Attempting to breach or probe security controls.</li>
              <li>Uploading malicious code or interfering with service operation.</li>
              <li>Using the service in a way that violates applicable laws.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Availability</h2>
            <p>
              We may modify, suspend, or discontinue the service at any time. We do
              not guarantee uninterrupted availability.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, Neurohubs is provided "as is"
              and "as available". We are not liable for indirect, incidental,
              special, consequential, or punitive damages.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-[#0B1120]">Contact</h2>
            <p>
              Questions about these terms: {" "}
              <a
                href="mailto:office@jointhubs.com"
                className="text-blue-600 hover:text-[#0B1120] transition-colors"
              >
                office@jointhubs.com
              </a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermsOfService;
